<template>
    <!-- eslint-disable -->
    <svg id="noun_Share_1736506" xmlns="http://www.w3.org/2000/svg" width="13.756" height="15.78" viewBox="0 0 13.756 15.78" v-on="$listeners">
        <g id="Groupe_416" data-name="Groupe 416" transform="translate(0 0)">
            <path id="Tracé_6" data-name="Tracé 6" d="M27.127,963.36a2.633,2.633,0,0,0-2.5,3.439l-4.343,2.415a2.612,2.612,0,0,0-1.65-.594,2.63,2.63,0,1,0,0,5.26,2.607,2.607,0,0,0,1.65-.588l4.349,2.415a2.58,2.58,0,0,0-.133.8,2.644,2.644,0,1,0,.765-1.846l-4.229-2.352a2.614,2.614,0,0,0,.228-1.062,2.587,2.587,0,0,0-.228-1.062l4.223-2.352a2.629,2.629,0,1,0,1.871-4.476Zm0,1.214a1.416,1.416,0,1,1-1.416,1.416A1.407,1.407,0,0,1,27.127,964.574Zm-8.5,5.26a1.416,1.416,0,1,1-1.416,1.416A1.407,1.407,0,0,1,18.63,969.834Zm8.5,5.26a1.416,1.416,0,1,1-1.416,1.416A1.407,1.407,0,0,1,27.127,975.094Z" transform="translate(-16 -963.36)" :fill="color"/>
        </g>
    </svg>
</template>
<script>
import { Colorable } from '../../mixins';

export default {
    name: 'IconShare',
    mixins: [Colorable],
};
</script>
